/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class Cockpit extends Model {
    resource() {
        return 'cockpit';
    }
}
